/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { costCalculatorAuthenticatedGetResponseSchema } from './costCalculatorAuthenticatedGetResponseSchema.ts';

/**
 * @description 200 response
 */
export const getCostCalculatorAuthenticated200Schema = z.lazy(() => costCalculatorAuthenticatedGetResponseSchema);

/**
 * @description 505 response
 */
export const getCostCalculatorAuthenticated505Schema = z.any();

export const getCostCalculatorAuthenticatedQueryResponseSchema = z.lazy(() => getCostCalculatorAuthenticated200Schema);
